import { Select, Tooltip, Text } from '@mantine/core';
import type { MyGroupEntry } from '@pta/types';
import { useAuth } from '../auth/AuthProvider';

/**
 * Header-be illeszkedő csoport-választó.
 * A user `myGroups` listájából választ; `activeGroupId`-t állít az AuthProvider-ben.
 *
 * Megjelenítés: csoport neve + intézmény-címke (institutionLabel: bound iskolanév
 * vagy free_text). Ha csak egy csoport van, csak Text-ként mutatja (nincs választás).
 * Ha nincs csoport, semmi (a Financial layout dashboard-ja külön kezeli az üres állapotot).
 */
export function GroupPicker() {
  const { myGroups, activeGroupId, setActiveGroupId } = useAuth();

  if (myGroups.length === 0) return null;

  if (myGroups.length === 1) {
    const g = myGroups[0]!;
    return (
      <Tooltip label={describeGroup(g)} withArrow>
        <Text size="sm" fw={500}>
          {g.name}
        </Text>
      </Tooltip>
    );
  }

  const data = myGroups.map((g) => ({
    value: String(g.id),
    label: `${describeGroup(g)} — ${g.name}`,
  }));

  return (
    <Select
      size="sm"
      w={320}
      data={data}
      value={activeGroupId !== null ? String(activeGroupId) : null}
      onChange={(v) => setActiveGroupId(v ? Number(v) : null)}
      placeholder="Csoport választása"
      allowDeselect={false}
      searchable
    />
  );
}

function describeGroup(g: MyGroupEntry): string {
  if (g.institutionLabel) return g.institutionLabel;
  return 'ismeretlen iskola';
}
